import { render, staticRenderFns } from "./ArchivePartModal.vue?vue&type=template&id=8b8ecc90&"
import script from "./ArchivePartModal.vue?vue&type=script&lang=js&"
export * from "./ArchivePartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports